import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import GoogleMapReact from 'google-map-react';
import {Marker} from "./Main";
import {TextInput} from "../modules/TextInput";
import {useNavigate} from "react-router-dom";
import {Button} from "../modules/Button";
import {useEffect, useReducer, useRef, useState} from "react";
import {
  isIOS,
  isPc,
  savePageVisit,
  SCREEN_WIDTH,
  sendFormRequest,
  sendRequest,
  validateEmail, validatePhone
} from "../static/js/common";


const FileInput = ({fileRef, files, setFiles}) => {

  return (
    <div className={'flex-column'}>
      <div className={'flex-row'} onClick={() => fileRef?.current?.click()}>
        <div className={'file-box'}>
          {/*accept={'image/jpg,image/png,application/pdf'} */}
          <input ref={fileRef} type={'file'} style={{display: 'none'}} onChange={e => {
            if(files.length > 2) {
              alert('파일은 3개까지만 등록할 수 있습니다.')
              return
            }
            const file_ = e?.target.files[0]
            if (file_?.size > 50 * 1024 * 1024) {
              alert('파일 용량은 50MB 이하로 업로드 해주세요.')
              return
            }
            files.push(file_)
            setFiles(Object.assign([], files))
          }}/>
          <img className={'icon-24'} src={require('../assets/images/attachment.png')}/>
        </div>
        <div className={'white font-24 margin-left-20'}
             style={{marginTop: -6}}>{'50MB 이하의 .jpg, .png, .pdf 파일 3개까지 업로드 가능'}</div>
      </div>
      <div className={'margin-top-20'}>
        {files?.map((item, index) => {
          return (
            <div className={'white font-20 margin-left-20'}>{item?.name}</div>
          )
        })}
      </div>
    </div>
  )
}

const MobileFileInput = ({fileRef, files, setFiles}) => {

  return (
    <div className={'flex-column'}>
      <div className={'flex-row'} onClick={() => fileRef?.current?.click()}>
        <div className={'file-box'}>
          {/*accept={'image/jpg,image/png,application/pdf'} */}
          <input ref={fileRef} type={'file'} style={{display: 'none'}} onChange={e => {
            if (files.length > 2) {
              alert('파일은 3개까지만 등록할 수 있습니다.')
              return
            }
            const file_ = e?.target.files[0]
            if (file_?.size > 50 * 1024 * 1024) {
              alert('파일 용량은 50MB 이하로 업로드 해주세요.')
              return
            }
            files.push(file_)
            setFiles(Object.assign([], files))
          }}/>
          <img className={'icon-24'} src={require('../assets/images/attachment.png')}/>
        </div>
        <div className={'white font-16 margin-left-20'}
             style={{marginTop: -6}}>{'50MB 이하의 .jpg, .png, .pdf 파일 3개까지 업로드 가능'}</div>
      </div>
      <div className={'margin-top-20'}>
        {files?.map((item, index) => {
          return (
            <div className={'white font-14 margin-left-20'}>{item?.name}</div>
          )
        })}
      </div>
    </div>
  )
}


export const Contact = ({}) => {

  const [mouseOver, setMouseOver] = useState(false);

  const defaultProps = {
    center: {
      lat: 37.508181,
      lng: 127.062797
    },
    zoom: 15
  };

  const navigate = useNavigate()

  const [projectName, setProjectName] = useState("")
  const [description, setDescription] = useState("")
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [organization, setOrganization] = useState("")
  const [email, setEmail] = useState("")
  const [agreePrivacy, setAgreePrivacy] = useState(false)
  const [files, setFiles] = useState([])
  const fileRef = useRef()
  const [agreePrivacyOnCareerTitle, setAgreePrivacyOnCareerTitle] = useState('')
  const [agreePrivacyOnCareer, setAgreePrivacyOnCareer] = useState('')

  const saveContact = () => {
    if (!projectName) {
      alert('프로젝트 명을 입력해 주세요.')
      return
    }

    if(!validatePhone(phone)) {
      alert('연락처는 숫자만 입력해 주세요.')
      return
    }

    if (!email || !validateEmail(email)) {
      alert('올바른 이메일을 입력해 주세요.')
      return
    }

    if (!agreePrivacy) {
      alert('개인정보보호정책에 동의해 주세요.')
      return
    }

    if (!files?.length) {
      alert('파일을 최소 1개 이상 업로드 해주세요.')
      return
    }

    sendRequest('contact/contact/', 'POST', {
      projectName,
      description,
      name,
      phone,
      organization,
      email,
      agreePrivacy,
    }, data => {
      if (files?.length) {
        const formData = new FormData();
        formData.append('file1', files[0])
        if(files?.length > 1) {
          formData.append('file2', files[1])
        }
        if(files?.length > 2) {
          formData.append('file3', files[2])
        }
        sendFormRequest(`contact/contact-file/${data?.id}/`, 'POST', formData, () => {
          navigate(-1)
        })
      } else {
        navigate(-1)
      }
    })

    alert('프로젝트 의뢰가 올바르게 신청 되었습니다.')
  }

  const getConfig = () => {
    sendRequest('config/config/?key=agreePrivacyOnContact', 'GET', null, data => {
      const agreement = data[0]
      setAgreePrivacyOnCareerTitle(agreement?.value)
      setAgreePrivacyOnCareer(agreement?.desc)
    })
  }

  useEffect(() => {
    getConfig()
    window.scroll(0, 0)
    savePageVisit('Contact')
  }, []);

  return (
    <div className={'flex-1 flex-column'}>
      {isPc ?
        <div>
          {/*<Header rightCancel/>*/}
          <div className={'absolute'} style={{right: '2vw', top: '4vh'}}>
            <div onClick={() => navigate(-1)}
                 onMouseEnter={() => setMouseOver(true)}
                 onMouseLeave={() => setMouseOver(false)}
            >
              <img className={'icon-36'}
                   src={require('../assets/images/cancel.png')}/>
            </div>
          </div>
          <div className={'flex-1 darkgray-bg'} style={{paddingTop: 80}}>
            <div className={'flex-row-wo-center flex-1'}>
              <div className={'flex-1'}>
                <div style={{height: '100%', width: '47.5vw', paddingLeft: '5vw'}}>
                  <GoogleMapReact
                    bootstrapURLKeys={{key: "AIzaSyAF9VXtNJ3iorhFO-wKZvtODU7mX8W12Q0"}}
                    defaultCenter={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                    yesIWantToUseGoogleMapApiInternals
                  >
                    <Marker lat={37.508181} lng={127.062797}/>
                  </GoogleMapReact>
                </div>
              </div>
              <div className={'flex-1'}>
                <div className={'contact-wrapper relative'}>
                  <div className={'white notosans-black font-30 whiter-border-bottom padding-bottom-40'}>프로젝트 문의하기</div>
                  {/*<div*/}
                  {/*  className={'absolute'} style={{right: 20, top: 20}}*/}
                  {/*  onClick={() => navigate(-1)}*/}
                  {/*>*/}
                  {/*  <img className={'icon-36'} src={require('../assets/images/big_close.png')}/>*/}
                  {/*</div>*/}

                  <div className={'margin-top-40'}>
                    <TextInput
                      placeholder={'프로젝트명'}
                      backgroundColor={'#272727'}
                      // height={55}
                      // padding={'1px 0 0 20px'}
                      value={projectName}
                      setValue={setProjectName}
                    />
                  </div>
                  <div className={'margin-top-40'}>
                    <TextInput
                      placeholder={'내용'}
                      backgroundColor={'#272727'}
                      height={219}
                      width={'calc(100% - 20px)'}
                      padding={'20px 0 0 20px'}
                      multiline={true}
                      value={description}
                      setValue={setDescription}
                    />
                  </div>
                  <div className={'margin-top-40 file-input-wrapper align-center'}>
                    <FileInput fileRef={fileRef} files={files} setFiles={setFiles}/>
                  </div>
                  <div className={'margin-top-32'}>
                    <div className={'flex-row'}>
                      <div className={'flex-1'}>
                        <TextInput placeholder={'성명'} value={name} setValue={setName} backgroundColor={'#252525'}/>
                      </div>
                      <div className={'flex-1'} style={{marginLeft: '3.5vw'}}>
                        <TextInput placeholder={'연락처'} value={phone} setValue={setPhone} backgroundColor={'#252525'}/>
                      </div>
                    </div>
                  </div>
                  <div className={'margin-top-32'}>
                    <div className={'flex-row'}>
                      <div className={'flex-1'}>
                        <TextInput placeholder={'회사명'} value={organization} setValue={setOrganization} backgroundColor={'#252525'}/>
                      </div>
                      <div className={'flex-1'} style={{marginLeft: '3.5vw'}}>
                        <TextInput placeholder={'이메일'} value={email} setValue={setEmail} backgroundColor={'#252525'}/>
                      </div>
                    </div>
                  </div>

                  <div className={'margin-top-32'}>
                    <div className={'flex-1 flex-column'}>
                      <div className={'flex-row'} onClick={() => setAgreePrivacy(!agreePrivacy)}>
                        <img className={'icon-22'}
                             src={agreePrivacy ? require('../assets/images/checkbox_on.png') : require('../assets/images/checkbox.png')}/>
                        <div className={`${agreePrivacy ? 'white' : 'gray'} notosans-bold font-20 margin-left-16`}>
                          <span className={''}>{agreePrivacyOnCareerTitle}</span>
                        </div>
                      </div>
                      <div className={'more-blur-white agreement pre-wrap'}>
                        {agreePrivacyOnCareer}
                      </div>
                    </div>
                  </div>

                  {/*<div className={'flex-center'} style={{marginTop: 90}}>*/}
                  {/*  <Button text={'프로젝트 문의하기'} width={263} height={69} onClick={saveContact}/>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </div>
          <div className={'darkgray-bg flex-center padding-bottom-80 padding-top-80'}>
            <img className={'career-btn'} src={require('../assets/images/contact_btn.png')} onClick={saveContact}/>
          </div>
        </div>
        :
        <div style={{width: SCREEN_WIDTH}}>
          <div className={'flex-1 black-bg'}>
            <div className={'flex-column flex-1'}>
              <div className={'flex-1'}>
                <div className={'mobile-contact-wrapper relative'}>
                  <div
                    className={'absolute'} style={{right: 42, top: 20}}
                    onClick={() => navigate(-1)}
                  >
                    <img className={'icon-28'} src={require('../assets/images/cancel.png')}/>
                  </div>

                  <div className={'margin-top-100'}>
                    <div className={'flex-column'}>
                      <div className={''}>
                        <TextInput placeholder={'성명'} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 52 : 36)}
                                   value={name} setValue={setName}/>
                      </div>
                      <div className={'margin-top-20'}>
                        <TextInput placeholder={'회사명'} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 52 : 36)}
                                   value={organization} setValue={setOrganization}/>
                      </div>
                    </div>
                  </div>
                  <div className={'margin-top-20'}>
                    <div className={'flex-column'}>
                      <div className={''}>
                        <TextInput placeholder={'이메일'} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 52 : 36)}
                                   value={email} setValue={setEmail}/>
                      </div>
                      <div className={'margin-top-20'}>
                        <TextInput placeholder={'연락처'} fontSize={16} width={SCREEN_WIDTH - (isIOS() ? 52 : 36)}
                                   value={phone} setValue={setPhone}/>
                      </div>
                    </div>
                  </div>

                  <div className={'margin-top-40'}>
                    <TextInput
                      placeholder={'제목'}
                      // backgroundColor={'#272727'}
                      width={SCREEN_WIDTH - (isIOS() ? 52 : 36)}
                      // height={44}
                      fontSize={16}
                      // padding={'1px 0 0 20px'}
                      value={projectName}
                      setValue={setProjectName}
                    />
                  </div>
                  <div className={'margin-top-20'}>
                    <TextInput
                      placeholder={'내용'}
                      backgroundColor={'#272727'}
                      width={SCREEN_WIDTH - 52}
                      height={219}
                      fontSize={16}
                      padding={'20px 0 0 20px'}
                      multiline={true}
                      // bottomComponent={<MobileFileInput fileRef={fileRef} setFile={setFile}/>}
                      value={description}
                      setValue={setDescription}
                    />
                  </div>

                  <div className={'margin-top-40 file-input-wrapper align-center'} style={{width: 'calc(100% - 98px)'}} >
                    <MobileFileInput fileRef={fileRef} files={files} setFiles={setFiles}/>
                  </div>

                  <div className={'margin-top-32'}>
                    <div className={'flex-1 flex-column'}>
                      <div className={'flex-row'} onClick={() => setAgreePrivacy(!agreePrivacy)}>
                        <img className={'icon-22'}
                             src={agreePrivacy ? require('../assets/images/checkbox_on.png') : require('../assets/images/checkbox.png')}/>
                        <div className={`${agreePrivacy ? 'white' : 'gray'} notosans-bold font-20 margin-left-16`}>
                          <span className={''}>{agreePrivacyOnCareerTitle}</span>
                        </div>
                      </div>
                      <div className={'more-blur-white mobile-agreement pre-wrap'} style={{width: `calc(100% - ${isIOS() ? '52px' : '36px'})`}}>
                        {agreePrivacyOnCareer}
                      </div>
                    </div>
                  </div>

                  <div className={'align-center'} style={{marginTop: 80, marginLeft: '-7vw'}}>
                    {/*<Button text={'서류 전송'} width={SCREEN_WIDTH - 32} height={69} onClick={saveContact}/>*/}
                    <img className={'career-btn'} style={{}} src={require('../assets/images/contact_btn.png')} onClick={saveContact}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={'flex-1 black-bg'} style={{paddingTop: 57}}>
            <div style={{height: '60vw', width: '100vw'}}>
            <GoogleMapReact
                bootstrapURLKeys={{key: "AIzaSyAF9VXtNJ3iorhFO-wKZvtODU7mX8W12Q0"}}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                yesIWantToUseGoogleMapApiInternals
              >
                <Marker lat={37.508181} lng={127.062797}/>
              </GoogleMapReact>
            </div>
          </div>
        </div>
      }
      <Footer/>
    </div>
  )
}
